// Utilitários de formatação compartilhados entre as páginas.
// Antes desta extração, formatarCNPJ existia copiado em 5 páginas fiscais
// e cada módulo redefinia sua própria formatação de moeda.

export const formatarCNPJ = (cnpj) => {
  if (!cnpj) return '';
  const limpo = String(cnpj).replace(/\D/g, '');
  if (limpo.length === 14) {
    return `${limpo.slice(0, 2)}.${limpo.slice(2, 5)}.${limpo.slice(5, 8)}/${limpo.slice(8, 12)}-${limpo.slice(12)}`;
  }
  return limpo;
};

const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
});

export const formatarMoeda = (valor) => brlFormatter.format(Number(valor) || 0);

// Escapa texto vindo do backend antes de interpolar em HTML montado por string
// (ex.: relatórios de impressão via document.write).
export const escapeHtml = (texto) =>
  String(texto ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
